<div *ngIf="showLoading" class="loading-div-tiny" aria-live="polite" aria-busy="true" role="alert" tabindex="2">
    <div class="loading-spinner">
        <div class="small progress" alt="Loading..."><div class="prog1"><div class="prog2"></div></div></div>
    </div>
</div>
<ng-container *ngIf="!showLoading">
    <div *ngIf="!boostYourPointsData || boostYourPointsData && boostYourPointsData.length === 0">
        <div class="boost-your-points-container">
            <div class="boost-your-points-logo-container">
                <img aria-hidden="true" class="boost-your-points-logo" src="/ocrp-rewards-ui/dist/assets/images/icon/empty-boost-points.svg" alt="Boost your points logo" />
            </div>

            <div class="boost-your-points-body">
                <h2 class="boost-your-points-heading-size">No Point boosters available at this time</h2>
                <p class="boost-your-points-description-text">You can still earn Points with every grocery purchase.</p>
            </div>
            <div class="boost-your-points-no-points-footer">
                <button type="button" class="btn btn-xl btn-primary body-text more-ways-to-use-no-points-footer__button" (click)="openRewardsPage()" (keypress)="openRewardsPage()" aria-label="Start earning, redirect to rewards page">
                    Start Earning
                </button>
            </div>
        </div>
    </div>
    <div *ngIf="boostYourPointsData && boostYourPointsData.length > 0">
        <div *ngIf="!showLoading" class="point-reward-grid-container">
            <div class="reward-grid">
                <ng-container *ngFor="let reward of boostYourPointsData">
                    <point-reward-card [ngClass]="rewardCardDisabled ? 'reward-grid-itme' : 'reward-card-container'"
                                       [reward]="reward" [appHostURL]="appHostURL"
                                       [userInfo]="userInfo" [currentEnvironment]="currentEnvironment"
                                       [enableCashReward]="enableCashReward" [isPointScoreCardFlow]="pointScoreCardFlow"
                                       [isBoostYourPointsCardFlow]="isBoostYourPointsCardFlow"
                                       [rewardsResponseObj]="rewardsResponseObj"
                                       (callBoostYourPointsApi)="triggerBoostYourPointsApi($event)"></point-reward-card>
                </ng-container>
            </div>
        </div>
    </div>
</ng-container>
